import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Image } from '@outdoor-voices/ui';
import { memo } from 'react';
import { useQuery } from 'urql';
import PropTypes from 'prop-types';
import { imageFragment } from '../../graphql/fragments';
import css from './Product.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var query = "\n  ".concat(imageFragment, "\n  query GetVariant($variantId: String) {\n    variantShopify(shopifyId: $variantId) {\n      colorway {\n        image {\n          ...image\n        }\n      }\n    }\n  }\n");
var IMAGE_SIZES = [110];
var FetchedImage = /*#__PURE__*/memo(function (_ref) {
  var variantId = _ref.variantId;

  var _useQuery = useQuery({
    query: query,
    variables: {
      variantId: variantId
    }
  }),
      _useQuery2 = _slicedToArray(_useQuery, 1),
      data = _useQuery2[0].data;

  var image = data && data.variantShopify ? data.variantShopify.colorway.image : false;

  if (!image) {
    return null;
  }

  return /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
    className: css.image,
    sizes: IMAGE_SIZES
  }));
});
FetchedImage.propTypes = {
  variantId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

var Product = function Product(_ref2) {
  var image = _ref2.image,
      reviewLink = _ref2.reviewLink,
      subtitle = _ref2.subtitle,
      title = _ref2.title,
      variantId = _ref2.variantId;
  return /*#__PURE__*/_jsxs("li", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.image,
      children: [variantId && /*#__PURE__*/_jsx(FetchedImage, {
        variantId: variantId
      }), !variantId && image && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
        height: 1200,
        width: 900,
        sizes: IMAGE_SIZES
      }))]
    }), /*#__PURE__*/_jsxs("div", {
      className: css.text,
      children: [/*#__PURE__*/_jsx("h3", {
        className: css.title,
        dangerouslySetInnerHTML: {
          __html: title
        }
      }), /*#__PURE__*/_jsx("p", {
        className: css.subtitle,
        children: subtitle
      }), reviewLink && /*#__PURE__*/_jsx("a", {
        className: css.reviewLink,
        href: reviewLink,
        children: "Write a Review"
      })]
    })]
  });
};

Product.defaultProps = {
  image: false,
  variantId: false
};
Product.propTypes = {
  image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  reviewLink: PropTypes.string,
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  variantId: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool])
};
export default /*#__PURE__*/memo(Product);